import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ImportDashboard } from "./components/import-dashboard";
import { ImportWizardSheet } from "./wizard";

export default function V2ImportPage() {
  const [wizardOpen, setWizardOpen] = useState(false);

  const newImportButton = (
    <Button size="sm" onClick={() => setWizardOpen(true)}>
      <Plus className="size-4" /> New import
    </Button>
  );

  return (
    <>
      <ImportDashboard
        breadcrumbs={[{ label: "Imports" }]}
        title="Imports"
        actions={newImportButton}
        emptyAction={{
          label: "New import",
          onClick: () => setWizardOpen(true),
        }}
      />
      <ImportWizardSheet open={wizardOpen} onOpenChange={setWizardOpen} />
    </>
  );
}
